export default "__VITE_ASSET__Cc3ZB_Rv__"